export default "__VITE_ASSET__fafaa780__"